




























































































































































































































































import CCategoryPicker from '~/components/shared/configurable/category/picker/CCategoryPicker.vue'
import {
  CategoryId,
  CategoryMapEntry,
  TreeLevelCategory
} from '~/models/category/types'
import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'
import {
  SET_ALL_CATEGORIES,
  SET_CATEGORY_ID
} from '~/store/modules/shared/classifieds/form/mutation-types'
import CCategorySearch from '~/components/shared/configurable/category/CCategorySearch.vue'
import {
  computed,
  defineComponent,
  nextTick,
  onBeforeUnmount,
  ref,
  toRefs,
  useContext,
  useRoute,
  useRouter,
  watch
} from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useNamespacedStore } from '~/compositions/store'
import { FieldChange } from '~/models/classified/form'
import { useDep } from '~/compositions/dependency-container'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { useId } from '~/compositions/id'
import {
  faArrowRight,
  faCheck,
  faTrashAlt
} from '@fortawesome/free-solid-svg-icons'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import { useUserAgent } from '~/compositions/user-agent'
import { Ref } from '@vue/composition-api'
import { vue3Set } from '~/utils/nuxt3-migration'
export default defineComponent({
  components: {
    CFormError,
    CConfirmationModal,
    CCategoryPicker,
    CCategorySearch
  },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const selectedCategoryForSelect = ref<number | null>(null)

    const { state, getters, commit, dispatch } = useNamespacedStore<FormState>(
      CLASSIFIED_FORM_NS
    )
    const inEditMode = computed(() => state.editMode)
    const categoriesForSelect = ref<TreeLevelCategory[]>([])
    const rootCategoryId = computed(() => specs.value?.root_category)

    function onValue(v: Ref) {
      let valueToSet
      if (Array.isArray(v.value)) {
        valueToSet = v.value.length ? v.value[0] : null
      } else {
        valueToSet = v.value || null
      }

      if (
        (categoriesForSelect.value.length === 0 &&
          rootCategoryId.value !== valueToSet) ||
        categoriesForSelect.value.some(c => c.id === valueToSet)
      ) {
        selectedCategoryForSelect.value = valueToSet
      } else {
        selectedCategoryForSelect.value = null
      }
    }
    const { value, valuesChanged, error } = useClassifiedForm(props, {
      onValue
    })

    const categoryMap = ref<Record<string, CategoryMapEntry>>({})
    const { uuid } = useId()

    const createCategoryRow = (collapse: boolean = false, _id?: number) => {
      const uid = uuid()
      const catObject: CategoryMapEntry = {
        selectedCategory: _id ? { id: _id } : undefined,
        editCollapse: collapse
      }
      categoryMap.value = {
        ...categoryMap.value,
        [uid.toString()]: catObject
      }
      return uid
    }

    const getCategoryList = () => {
      const fakeValue = Array.isArray(value.value)
        ? value.value
        : [value.value || null]
      return fakeValue.map(v => createCategoryRow(inEditMode.value, v))
    }

    const categoryList = ref<any[]>([...getCategoryList()])

    const addCategory = () => {
      categoryList.value.push(createCategoryRow(false))
    }

    const loaded = ref(false)

    const uidToDelete = ref('')
    const showDeleteConfirm = ref(false)
    const uidToMakePrimary = ref('')
    const showMakePrimaryConfirm = ref(false)
    const selectedCategory = ref<TreeLevelCategory | null>(null)
    const { isMobile } = useUserAgent()
    const legacyUrlService = useDep(LegacyUrlService)

    const route = useRoute()
    const router = useRouter()
    const { store } = useContext()

    const getSiblingIdsForUid = (uid: number) => {
      if (inEditMode.value) {
        return categoryList.value
          .filter(c => c !== uid)
          .map(c => categoryMap.value[c].selectedCategory?.id)
      }
      return []
    }

    watch(rootCategoryId, _val => {
      categoryList.value = [...getCategoryList()]
    })

    const categoryId = computed(() => state.categoryId)
    const allCategories = computed(() => state.allCategories)
    const isForRentals = computed(
      () => rootCategoryId.value === CategoryId.RENTALS
    )
    const isForJobs = computed(() => rootCategoryId.value === CategoryId.JOBS)
    const isVehiclesForm = computed(() => getters('isVehiclesForm'))

    const showCategorySelect = computed(() => {
      return isVehiclesForm.value && categoriesForSelect.value.length
    })
    const isVehiclesXymaOrPartsForm = computed(() =>
      getters('isVehiclesXymaOrPartsForm')
    )
    const isPlotForm = computed(() => getters('isPlotForm'))

    const schemaExtras = computed(() => state.extras)

    const categories = computed(() => specs?.value?.categories)
    const selectedCategoryIsNonFinal = (uid: string) => {
      const selectedCategory = categoryMap.value[uid]?.selectedCategory
      return !selectedCategory || selectedCategory.hasChildren
    }
    const pickerRef = ref(null)

    const handleLoad = (
      uid: string,
      fetchedRootCategory: TreeLevelCategory
    ) => {
      categoryMap.value[uid].selectedCategory = fetchedRootCategory

      if (
        categoryMap.value[uid].selectedCategory?.hasChildren &&
        categoryMap.value[uid].editCollapse
      ) {
        categoryMap.value[uid].editCollapse = false
      }
      loaded.value = true
    }

    const valueFinal = computed(() => {
      let valuesAsArray = categoryList.value.map(
        c => categoryMap.value[c].selectedCategory?.id
      )

      const baseCat = allCategories.value.find(c => c.isBase)
      if (baseCat && valuesAsArray.includes(baseCat.id)) {
        // move baseCat to the front of the array so backend always has the correct primary sent at 0 index
        valuesAsArray = valuesAsArray.filter(id => id !== baseCat.id)
        valuesAsArray.unshift(baseCat.id)
      }

      return valuesAsArray.length === 1 && !isVehiclesXymaOrPartsForm.value // true for plot and jobs
        ? valuesAsArray[0]
        : valuesAsArray
    })

    const numberOfAllowedCats = computed(() => {
      if (inEditMode.value) {
        return specs.value.max_allowed_categories || 1
      }
      return 1
    })

    const handleCategoryChange = async (
      uid: string,
      category: TreeLevelCategory,
      fromHistory = false
    ) => {
      if (!categoryMap.value[uid]) {
        throw new TypeError(`No category found with uid: ${uid}`)
      }

      if (categoryMap.value[uid].editCollapse && !fromHistory) {
        vue3Set(categoryMap.value, uid, {
          ...categoryMap.value[uid],
          editCollapse: false
        })
        return
      }

      const settingToSameCategory =
        categoryMap.value[uid].selectedCategory?.id === category.id
      categoryMap.value[uid].selectedCategory = category

      const uidIndex = categoryList.value.findIndex(c => c === uid)
      if (uidIndex === 0 && category.id !== -1) {
        // this is the first category so its primary, therefore set the global category to this one
        commit(SET_CATEGORY_ID, category.id)
      }
      if (showCategorySelect.value) {
        selectedCategoryForSelect.value = category.id
      }
      if (!fromHistory) {
        emitChanges()

        if (!category.hasChildren && !settingToSameCategory) {
          if (!inEditMode.value) {
            // we just changed the base category so make the new one base
            // only in new classified, in edit it will get saved with form save
            await dispatch('submitCategoryChange', valueFinal.value)
            if (!allCategories.value.some(c => c.isBase)) {
              uidToMakePrimary.value = uid
              onMakePrimaryConfirm()
            }
          } else if (!allCategories.value.some(c => c.id === uid)) {
            // we just added a new final category thats not in allCategories
            // we should add it
            commit(SET_ALL_CATEGORIES, [
              ...allCategories.value,
              {
                ...category,
                categoryIds: [category.parentId, category.id],
                isBase: false
              }
            ])
          }
        }
      }

      if (!inEditMode.value && category.id !== -1) {
        window.history.pushState(
          {},
          '',
          router.resolve({
            params: { categoryId: category.id.toString() },
            query: route.value.query
          }).href
        )
      }

      if (
        inEditMode.value &&
        !categoryMap.value[uid].editCollapse &&
        !categoryMap.value[uid].selectedCategory?.hasChildren &&
        !fromHistory
      ) {
        // just selected a final category so go back to collapse
        vue3Set(categoryMap.value, uid, {
          ...categoryMap.value[uid],
          editCollapse: true
        })
      }

      if (
        isMobile.value &&
        !showCategorySelect.value &&
        !category.hasChildren &&
        !category.isActive
      ) {
        await nextTick()
        const fieldsetElem = document.getElementById('categoryFieldset')
        if (fieldsetElem) {
          fieldsetElem.scrollIntoView()
        } else {
          window.scrollTo({ top: 0 })
        }
      }
    }
    const emitChanges = () => {
      const categoryRelatedChanges: FieldChange[] = [
        {
          name: name.value,
          value: valueFinal.value
        }
      ]

      if (isPlotForm.value) {
        // Nullify specials
        categoryRelatedChanges.push({
          name: 'specials',
          value: null
        })
        // Nullify trades_settings
        categoryRelatedChanges.push({
          name: 'trades_settings',
          value: null
        })
        // Nullify only_trades
        categoryRelatedChanges.push({
          name: 'only_trades',
          value: null
        })
      }
      valuesChanged(categoryRelatedChanges)
    }

    const getCategoryForUid = (uid: string) => {
      if (categoryMap.value[uid]) {
        const selectedID = categoryMap.value[uid].selectedCategory?.id
        const uidIndex = categoryList.value.findIndex(c => c === uid)
        if (!selectedID && uidIndex === 0) {
          return categoryId.value
        }
        return selectedID
      }

      return categoryId.value
    }

    const getEditCollapseForUid = (uid: string) => {
      if (categoryMap.value[uid]) {
        return categoryMap.value[uid].editCollapse
      }

      return false
    }

    const unsubscribe = store.subscribeAction(async action => {
      if (
        action.type === `${CLASSIFIED_FORM_NS}/changeFieldFromHistory` &&
        action.payload.name === 'category'
      ) {
        let uidIndex = 0
        if (Array.isArray(action.payload.value)) {
          if (action.payload.value.length === categoryList.value.length) {
            uidIndex = action.payload.value.findIndex(
              (c: number, index: number) => {
                const uid = categoryList.value[index]
                return c !== categoryMap.value[uid].selectedCategory?.id
              }
            )
          } else {
            // we got a new addition or removal
            categoryList.value = [
              ...action.payload.value.map(v =>
                createCategoryRow(inEditMode.value, v)
              )
            ]

            await dispatch('submitCategoryChange', valueFinal.value)

            // super edge case behavior, not sure if it will fork for every situation
            // because index will always be 0 here, so first category always, not the one from history
            if (!allCategories.value.some(c => c.isBase)) {
              // we just changed the base category so make the new one base
              uidToMakePrimary.value = categoryList.value[uidIndex]
              onMakePrimaryConfirm()
            }
            return
          }
        }

        const cat = await pickerRef.value[uidIndex]?.loadCategoryLevels(
          action.payload.value[uidIndex],
          true
        )

        if (process.client) {
          handleCategoryChange(categoryList.value[uidIndex], cat, true)
        }
      }
    })

    const onlyDealersAllowed = computed(() => {
      return getters('onlyDealersAllowedGuard')
    })

    const deleteClicked = (uid: string) => {
      uidToDelete.value = uid
      showDeleteConfirm.value = true
    }

    const onDeleteConfirm = async () => {
      const indexToDelete = categoryList.value.findIndex(
        c => c === uidToDelete.value
      )
      if (indexToDelete < 0 || indexToDelete > categoryList.value.length) {
        throw new TypeError(`Delete index out of bounds`)
      }
      categoryList.value.splice(indexToDelete, 1)

      emitChanges()
      await dispatch('submitCategoryChange', valueFinal.value)
    }

    const makePrimaryClicked = (uid: string) => {
      uidToMakePrimary.value = uid
      showMakePrimaryConfirm.value = true
    }

    const onMakePrimaryConfirm = async () => {
      if (!inEditMode.value) {
        return
      }
      const uidIndex = categoryList.value.findIndex(
        c => c === uidToMakePrimary.value
      )
      if (uidIndex < 0 || uidIndex > categoryList.value.length) {
        throw new TypeError(`Make-primary index out of bounds`)
      } else if (!categoryMap.value[uidToMakePrimary.value]?.selectedCategory) {
        throw new TypeError(`No category found during onMakePrimaryConfirm`)
      }

      await dispatch(
        'makeCategoryIdPrimary',
        categoryMap.value[uidToMakePrimary.value].selectedCategory.id
      )
      emitChanges()
    }

    const isUidPrimary = (uid: string) => {
      return allCategories.value.some(
        a => a.isBase && a.id === categoryMap.value[uid]?.selectedCategory?.id
      )
    }

    const isUidFinal = (uid: string) => {
      return categoryMap.value[uid]?.selectedCategory?.hasChildren === false
    }

    onBeforeUnmount(() => {
      unsubscribe()
    })

    const rootCategoryLabel = computed(() => {
      let foundPath = null

      if (specs.value) {
        specs.value.categories.forEach(c => {
          if (foundPath) {
            return
          }
          foundPath = c.path.find(p => p.id === rootCategoryId.value)
        })
      }

      if (foundPath?.human_name) {
        return foundPath.human_name
      }
      return ''
    })

    const displayRecents = computed(() => {
      // do not enable for vehicles without debugging
      return [CategoryId.PARTS, CategoryId.XYMA, CategoryId.JOBS].includes(
        rootCategoryId.value
      )
    })

    const onLevelsLoad = (levels: TreeLevelCategory[][]) => {
      categoriesForSelect.value = levels?.length
        ? levels[levels.length - 1]
        : []
    }

    const categoriesAsOptions = computed(() =>
      categoriesForSelect.value.map(c => {
        return { text: c.humanName, value: c.id }
      })
    )

    const handleSelectCategoryChange = (categoryId: number) => {
      const cat = categoriesForSelect.value.find(c => c.id === categoryId)

      handleCategoryChange(categoryList.value[0], cat)
    }

    return {
      categoryList,
      categories,
      categoriesForSelect,
      addCategory,
      createCategoryRow,
      loaded,
      selectedCategory,
      rootCategoryId,
      categoryId,
      selectedCategoryIsNonFinal,
      isForRentals,
      isForJobs,
      handleLoad,
      handleCategoryChange,
      error,
      uidToDelete,
      valueFinal,
      showDeleteConfirm,
      onDeleteConfirm,
      deleteClicked,
      makePrimaryClicked,
      onMakePrimaryConfirm,
      uidToMakePrimary,
      showMakePrimaryConfirm,
      unsubscribe,
      pickerRef,
      schemaExtras,
      onlyDealersAllowed,
      legacyUrlService,
      inEditMode,
      numberOfAllowedCats,
      categoryMap,
      getEditCollapseForUid,
      getCategoryForUid,
      faCheck,
      faTrashAlt,
      isUidPrimary,
      isUidFinal,
      getSiblingIdsForUid,
      allCategories,
      rootCategoryLabel,
      faArrowRight,
      displayRecents,
      onLevelsLoad,
      categoriesAsOptions,
      isMobile,
      isVehiclesForm,
      handleSelectCategoryChange,
      selectedCategoryForSelect,
      showCategorySelect
    }
  }
})
